import React from 'react'
import OrdersContainer from 'containers/panel/reseller/orders-container'

const OrdersPage = () => {
  return (
    <OrdersContainer/>
  )
}

export default OrdersPage